import React from 'react';

function SelectionCard({ 
  title, 
  description, 
  selected, 
  onClick, 
  className = '',
  children 
}) {
  return (
    <button
      onClick={onClick}
      className={`p-4 border-2 rounded-lg text-left transition-all duration-200 hover:shadow-lg ${
        selected
          ? 'border-[#FF5841] bg-[#FFEDEB] text-[#FF5841]'
          : 'border-gray-300 bg-white hover:border-gray-400'
      } ${className}`}
    >
      {title && (
        <h4 className="font-medium mb-1">{title}</h4>
      )}
      {description && (
        <p className="text-sm text-gray-600">{description}</p>
      )}
      {children}
    </button>
  );
}

export default SelectionCard;